(() => {
  if (customElements.get('score-progress-reviews')) return

  class ScoreProgressReviews extends HTMLElement {
    constructor() {
      super()
      this.onClick = this.onClick.bind(this)
      this.onBlockSelect = this.onBlockSelect.bind(this)
    }

    connectedCallback() {
      if (this.initialized) return

      this.initialized = true
      this.addEventListener('click', this.onClick)
      document.addEventListener('shopify:block:select', this.onBlockSelect)
      this.closeAll(this.querySelector('[data-score-progress-item].is-open'))
      this.syncOpenState()
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick)
      document.removeEventListener('shopify:block:select', this.onBlockSelect)
      this.initialized = false
    }

    onClick(event) {
      const toggle = event.target.closest?.('[data-score-progress-toggle]')

      if (!toggle || !this.contains(toggle)) return

      const item = toggle.closest('[data-score-progress-item]')
      const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true'

      this.closeAll(item)
      this.setItemState(item, shouldOpen)
    }

    onBlockSelect(event) {
      const item = event.target.closest?.('[data-score-progress-item]')

      if (!item || !this.contains(item)) return

      this.closeAll(item)
      this.setItemState(item, true)
    }

    closeAll(exceptItem) {
      this.querySelectorAll('[data-score-progress-item].is-open').forEach((item) => {
        if (item !== exceptItem) this.setItemState(item, false)
      })
    }

    setItemState(item, open) {
      if (!item) return

      const toggle = item.querySelector('[data-score-progress-toggle]')
      const panel = item.querySelector('[data-score-progress-panel]')

      item.classList.toggle('is-open', open)
      toggle?.setAttribute('aria-expanded', String(open))
      panel?.setAttribute('aria-hidden', String(!open))

      this.syncOpenState()
    }

    syncOpenState() {
      this.classList.toggle(
        'has-open-item',
        Boolean(this.querySelector('[data-score-progress-item].is-open'))
      )
    }
  }

  customElements.define('score-progress-reviews', ScoreProgressReviews)
})()
